var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPatientSearch = function SvgPatientSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 29,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "patientSearch_svg__a",
    width: 28,
    height: 29,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 .5h28v28H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#patientSearch_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    d: "M12.834 14.141q-1.684 0-2.884-1.2t-1.2-2.883 1.2-2.884 2.884-1.2 2.884 1.2q1.2 1.199 1.2 2.884t-1.2 2.884-2.884 1.199m0-1.75q.963 0 1.648-.685a2.25 2.25 0 0 0 .685-1.648q0-.963-.685-1.648a2.25 2.25 0 0 0-1.648-.686q-.963 0-1.648.686a2.25 2.25 0 0 0-.685 1.648q0 .961.685 1.648a2.25 2.25 0 0 0 1.648.685m11.82 13.99-2.805-2.803a5.5 5.5 0 0 1-1.246.583 4.4 4.4 0 0 1-1.35.21q-1.931 0-3.278-1.348-1.346-1.35-1.346-3.276t1.349-3.273q1.348-1.346 3.275-1.346t3.273 1.348q1.347 1.349 1.346 3.274 0 .697-.21 1.353-.211.656-.584 1.245l2.805 2.805a.85.85 0 0 1 .248.609.83.83 0 0 1-.248.62.84.84 0 0 1-.615.253.84.84 0 0 1-.615-.253m-5.403-3.76q1.213 0 2.043-.828.828-.83.828-2.043t-.828-2.043q-.83-.828-2.043-.829-1.214 0-2.043.83-.83.828-.83 2.042t.83 2.043q.828.83 2.043.829M4.084 21.254v-.803q0-.868.457-1.596a3.1 3.1 0 0 1 1.253-1.132q1.191-.62 2.85-1.118a12.8 12.8 0 0 1 3.447-.531.79.79 0 0 1 .633.232q.26.258.26.622a.88.88 0 0 1-.26.633.99.99 0 0 1-.633.305q-1.875.093-3.27.546t-2.206.872a1.4 1.4 0 0 0-.576.492 1.2 1.2 0 0 0-.205.675v.826h6.107q.372 0 .624.251a.85.85 0 0 1 .251.624.85.85 0 0 1-.252.623.85.85 0 0 1-.623.252H5.856a1.7 1.7 0 0 1-1.255-.517 1.7 1.7 0 0 1-.517-1.256"
  }))));
};
export default SvgPatientSearch;